<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>{{ settings.icon }}</mat-icon>
      {{ settings.title }}
    </h1>
  </section>
  <section mat-dialog-content>
    @if (settings.refund) {
      <section>
        <p>
          Please add a note as to why this order has been cancelled and returned
          to stock.
        </p>
        @if (Order.notes) {
          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>account_circle</mat-icon>
              </div>
              <mat-card-title>Existing notes</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <pre>{{ Order.notes }}</pre>
            </mat-card-content>
          </mat-card>
        }
      </section>
    }
    <mat-form-field>
      <mat-label>Notes</mat-label>
      <textarea formControlName="notes" matInput></textarea>
    </mat-form-field>

    @if (settings.refund) {
      <mat-card class="warning">
        <mat-card-header>
          <div mat-card-avatar>
            <mat-icon>warning</mat-icon>
          </div>
          <mat-card-title
            >This will not refund any money, purely mark the order as refunded and
            return the items to stock.<br />
            All financial's has to be done through worldpay manually.
          </mat-card-title>
        </mat-card-header>
      </mat-card>
    }
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
      >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid"
      mat-button
      matTooltip="Save order notes."
      type="submit"
      >
      <mat-icon>{{ settings.icon }}</mat-icon>
      {{ settings.buttonText }}
    </button>
  </section>
</form>
